export type ResourceCategory = '등급신청' | '복지서비스' | '정책제도' | '시설평가' | '치매'

export interface GovernmentResource {
  id: string
  name: string
  description: string
  url: string
  category: ResourceCategory
}

export const GOVERNMENT_RESOURCES: GovernmentResource[] = [
  {
    id: 'longtermcare',
    name: '국민건강보험공단 장기요양',
    description: '장기요양등급 신청, 판정 기준, 급여 안내',
    url: 'https://www.longtermcare.or.kr',
    category: '등급신청',
  },
  {
    id: 'longtermcare-search',
    name: '노인장기요양보험 시설찾기',
    description: '공단 공식 장기요양기관 검색 서비스',
    url: 'https://www.longtermcare.or.kr/npbs/e/b/501/npeb501m01.web',
    category: '등급신청',
  },
  {
    id: 'bokjiro',
    name: '복지로',
    description: '복지 서비스 통합 안내, 수급자격 조회',
    url: 'https://www.bokjiro.go.kr',
    category: '복지서비스',
  },
  {
    id: 'mohw',
    name: '보건복지부',
    description: '노인복지 정책, 제도 안내, 법령 정보',
    url: 'https://www.mohw.go.kr',
    category: '정책제도',
  },
  {
    id: 'hira',
    name: '건강보험심사평가원',
    description: '요양병원·시설 평가 정보, 진료비 확인',
    url: 'https://www.hira.or.kr',
    category: '시설평가',
  },
  {
    id: 'nid',
    name: '중앙치매센터',
    description: '치매 상담(1899-9988), 검진, 돌봄 서비스',
    url: 'https://www.nid.or.kr',
    category: '치매',
  },
]

/** 카테고리별 그룹 */
export const RESOURCE_CATEGORIES: { category: ResourceCategory; label: string; description: string }[] = [
  { category: '등급신청', label: '등급 신청·판정', description: '장기요양등급 신청과 판정 관련' },
  { category: '복지서비스', label: '복지 서비스', description: '각종 복지 혜택과 수급자격 확인' },
  { category: '정책제도', label: '정책·제도', description: '노인복지 관련 정책과 법령' },
  { category: '시설평가', label: '시설 평가', description: '요양기관 공식 평가 정보' },
  { category: '치매', label: '치매 관련', description: '치매 상담, 검진, 돌봄 서비스' },
]
